import { useQuery } from "@apollo/client";
import { LinearProgress } from "@material-ui/core";
import { GetShiftsByDateQueryResult } from "generated/graphql";
import { GET_SHIFTS_BY_DATE } from "lib/buildings";
import React from "react";
import ReportPdf from "./ReportPdf";

interface ReportProps {
  shiftStartDate?: string
  shiftNumber?: number
  buildingId?: string
}
export default function Report({ shiftStartDate, shiftNumber, buildingId}:ReportProps) {
  const { loading, error, data }:GetShiftsByDateQueryResult  = useQuery(GET_SHIFTS_BY_DATE, {variables: {
    buildingId: buildingId,
    _gte: shiftStartDate,
  }})
  
  console.log("🚀 ~ file: Report.tsx ~ line 14 ~ Report ~ data", data)

  if (loading) {
    return <LinearProgress />;
  } else if(data && shiftNumber) {
    const shift = data.Shift[shiftNumber];
    return <ReportPdf shiftId = {shift.Id}/>;
  }else {
    return <div>Error</div>
  }
}
